import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";

const PROJECTS = [
  { img: "/assets/hotel.jpg", cat: "Web Design", title: "Hotel Vittoria", desc: "Sito web & booking experience", tall: true },
  { img: "/menu-assets/hero.jpg", cat: "Menu Digitali", title: "L'Arte del Gusto", desc: "Menu digitale interattivo, multilingua, pronto per QR e NFC", href: "/menu" },
  { img: "/assets/card-duo.jpg", cat: "NFC", title: "Card Recensio", desc: "Card NFC per recensioni Google e Instagram" },
  { img: "/assets/food.jpg", cat: "Fotografia", title: "Ristorante Sella", desc: "Editorial food photography", tall: true },
  { img: "/assets/seaside.jpg", cat: "Video & Drone", title: "Lido Azzurro", desc: "Riprese e contenuti per locali sul mare" },
  { img: "/assets/dessert.jpg", cat: "Fotografia", title: "Bistrò Noir", desc: "Still life e dessert editoriali" },
];

const Portfolio = () => (
  <section id="portfolio" data-testid="portfolio-section" className="relative py-28 lg:py-40">
    <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
      <div className="mb-20 flex flex-wrap items-end justify-between gap-10">
        <Reveal>
          <Overline className="mb-6">Portfolio</Overline>
          <h2 className="font-display text-4xl font-medium leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
            Lavori che parlano<br /><span className="gold-text italic">da soli.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="max-w-sm text-base font-light leading-relaxed text-[#A3A3A3]">
            Una selezione di progetti per locali che hanno scelto di distinguersi.
          </p>
        </Reveal>
      </div>

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {PROJECTS.map((p, i) => (
          <Reveal key={p.title} delay={0.08 * (i % 3)} className={p.tall ? "lg:mt-16" : ""}>
            <a
              href={p.href || "#contatti"}
              data-testid={`portfolio-item-${p.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="group relative block overflow-hidden"
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                {p.video ? (
                  <video
                    poster={p.img}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="metadata"
                    data-testid={`portfolio-video-${p.title.toLowerCase().replace(/\s+/g, "-")}`}
                    className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
                  >
                    <source src="/assets/drone-restaurant.webm" type="video/webm" />
                    <source src={p.video} type="video/mp4" />
                  </video>
                ) : (
                  <img
                    src={p.img}
                    alt={`${p.title} — ${p.cat}`}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent opacity-80 transition-opacity duration-700 group-hover:opacity-95" />
                <div className="absolute inset-4 border border-[#C19D60]/0 transition-[border-color] duration-700 group-hover:border-[#C19D60]/40" />
              </div>
              <div className="absolute inset-x-0 bottom-0 p-7">
                <p className="text-[10px] uppercase tracking-[0.3em] text-[#C19D60]">{p.cat}</p>
                <div className="mt-2 flex items-end justify-between gap-4">
                  <div>
                    <h3 className="font-display text-2xl font-medium tracking-tight text-[#F8F5F0]">{p.title}</h3>
                    <p className="mt-1 max-w-[240px] translate-y-2 text-xs font-light text-[#c9c9c9] opacity-0 transition-[opacity,transform] duration-700 group-hover:translate-y-0 group-hover:opacity-100">
                      {p.desc}
                    </p>
                  </div>
                  <ArrowUpRight size={20} strokeWidth={1.2} className="shrink-0 text-[#C19D60] opacity-0 transition-opacity duration-700 group-hover:opacity-100" />
                </div>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Portfolio;
